/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AdminAddContactInfoConfirmationActionEnum {
  merge = "merge",
  steal = "steal",
}

export enum AutoContentInfo {
  contact_information = "contact_information",
  grade = "grade",
  name = "name",
  name_of_child = "name_of_child",
  preferred_language = "preferred_language",
  role = "role",
  school = "school",
  student_id = "student_id",
}

export enum AutoMessageStatus {
  active = "active",
  draft = "draft",
  inactive = "inactive",
}

/**
 * https: // github.com/remind101/r101-api/blob/4649ee86a7132d4b21fd9236e9ff57b5906854e4/app/loaders/related_user_view.rb#L124-L138
 */
export enum ChatEligibilityState {
  eligible = "eligible",
  pending = "pending",
  unavailable = "unavailable",
  under_13 = "under_13",
  unknown = "unknown",
}

export enum ClassMembershipRole {
  owner = "owner",
  subscriber = "subscriber",
}

export enum ClassMembershipsSortDirection {
  asc = "asc",
  desc = "desc",
}

export enum ClassMembershipsSortType {
  first_name = "first_name",
  join_date = "join_date",
  joined_remind_date = "joined_remind_date",
  last_name = "last_name",
  role = "role",
}

export enum ClassSearchability {
  searchable = "searchable",
  unsearchable = "unsearchable",
}

export enum ClassType {
  available = "available",
  district = "district",
  organization = "organization",
  owned = "owned",
  pending = "pending",
  subscribed = "subscribed",
}

export enum ContactabilityStatus {
  ghost = "ghost",
  poor = "poor",
  rich = "rich",
  uncontactable = "uncontactable",
}

export enum DeliverySummaryUnidentifiableReason {
  missing_parents = "missing_parents",
  missing_student = "missing_student",
}

export enum DeviceType {
  apns = "apns",
  email = "email",
  gcm = "gcm",
  landline = "landline",
  sms = "sms",
}

export enum DirectAddErrorType {
  already_joined = "already_joined",
  blocked = "blocked",
  cannot_join = "cannot_join",
  contains_url = "contains_url",
  invalid_preferred_language_code = "invalid_preferred_language_code",
  invalid_type = "invalid_type",
  invalid_type_sms = "invalid_type_sms",
  loop = "loop",
  not_allowed = "not_allowed",
  profane_name = "profane_name",
  too_soon = "too_soon",
  unspecified_error = "unspecified_error",
  unsupported = "unsupported",
}

export enum EntityType {
  group = "group",
  organization = "organization",
}

export enum LanguageSetInputTargetType {
  group = "group",
  groupChat = "groupChat",
  individual = "individual",
  organization = "organization",
}

export enum LanguageSetRecipientsGrade {
  COL = "COL",
  G01 = "G01",
  G02 = "G02",
  G03 = "G03",
  G04 = "G04",
  G05 = "G05",
  G06 = "G06",
  G07 = "G07",
  G08 = "G08",
  G09 = "G09",
  G10 = "G10",
  G11 = "G11",
  G12 = "G12",
  KG = "KG",
  NA = "NA",
  PK = "PK",
  any = "any",
}

export enum LanguageSetRecipientsRole {
  admin = "admin",
  employee = "employee",
  parent = "parent",
  staff = "staff",
  student = "student",
  teacher = "teacher",
}

export enum LanguageSetRecipientsRostered {
  any = "any",
  nonrostered = "nonrostered",
  rostered = "rostered",
}

export enum LegacyMessageStatus {
  failed = "failed",
  pending = "pending",
  received = "received",
  scheduled = "scheduled",
  sent = "sent",
}

export enum LegacyUserRole {
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export enum LinkClassToOrgRequestStatus {
  approved = "approved",
  denied = "denied",
  requested_approval = "requested_approval",
  unknown = "unknown",
}

export enum MediumEnum {
  apns = "apns",
  email = "email",
  fake = "fake",
  gcm = "gcm",
  landline = "landline",
  sms = "sms",
}

export enum MessageRecipientsGrade {
  COL = "COL",
  G01 = "G01",
  G02 = "G02",
  G03 = "G03",
  G04 = "G04",
  G05 = "G05",
  G06 = "G06",
  G07 = "G07",
  G08 = "G08",
  G09 = "G09",
  G10 = "G10",
  G11 = "G11",
  G12 = "G12",
  KG = "KG",
  NA = "NA",
  PK = "PK",
  any = "any",
}

export enum MessageRecipientsRole {
  admin = "admin",
  employee = "employee",
  everyone = "everyone",
  parent = "parent",
  staff = "staff",
  student = "student",
  teacher = "teacher",
}

export enum MessageRecipientsRostered {
  any = "any",
  nonrostered = "nonrostered",
  rostered = "rostered",
}

export enum MessageTranslationIntent {
  auto = "auto",
  edited = "edited",
  off = "off",
}

export enum MessageTranslationSource {
  custom = "custom",
  detectLanguage = "detectLanguage",
  gct = "gct",
  off = "off",
  unknown = "unknown",
}

export enum MessageVisibilityEnum {
  hidden = "hidden",
}

export enum NavigationListActionTarget {
  create_group = "create_group",
  join_group = "join_group",
}

export enum NavigationListEntityType {
  group = "group",
  organization = "organization",
}

export enum OrgPermission {
  can_send_auto_message = "can_send_auto_message",
}

export enum OrgRole {
  admin = "admin",
  employee = "employee",
  everyone = "everyone",
  parent = "parent",
  rce = "rce",
  staff = "staff",
  student = "student",
  teacher = "teacher",
  unknown = "unknown",
}

export enum OrganizationChartsDeviceType {
  app = "app",
  email = "email",
  sms = "sms",
}

export enum OrganizationChartsMessageDeliveryStatusFilter {
  notReceived = "notReceived",
  received = "received",
}

export enum OrganizationChartsMessageFrequency {
  daily = "daily",
  monthly = "monthly",
  weekly = "weekly",
}

export enum OrganizationChartsMessageType {
  announcement = "announcement",
  chat = "chat",
}

export enum OrganizationChartsReachabilityStatusFilter {
  reachable = "reachable",
  unreachable = "unreachable",
}

export enum OrganizationChartsReachabilityType {
  noDevice = "noDevice",
  optedIn = "optedIn",
  optedOut = "optedOut",
}

export enum OrganizationChartsSenderRole {
  admin = "admin",
  teacher = "teacher",
}

export enum OrganizationChartsUserRole {
  admin = "admin",
  employee = "employee",
  none = "none",
  parent = "parent",
  staff = "staff",
  student = "student",
  teacher = "teacher",
}

export enum OrganizationRole {
  admin = "admin",
  employee = "employee",
  parent = "parent",
  rce = "rce",
  staff = "staff",
  student = "student",
  teacher = "teacher",
}

export enum OrganizationRoleOrUnknown {
  admin = "admin",
  employee = "employee",
  parent = "parent",
  rce = "rce",
  staff = "staff",
  student = "student",
  teacher = "teacher",
  unknown = "unknown",
}

/**
 * https: // github.com/remind101/r101-api/blob/8d1121436a6ae5e5f955330dd31b3209fc2f1e82/app/loaders/organization.rb#L25
 */
export enum OrganizationType {
  District = "District",
  School = "School",
}

export enum ParticipantMessagingState {
  open = "open",
  ownerOrSameRole = "ownerOrSameRole",
  ownersOnly = "ownersOnly",
}

export enum PhoneCallStatusLocalizationKey {
  canceled = "canceled",
  failed = "failed",
  in_progress = "in_progress",
  incoming = "incoming",
  missed = "missed",
  outgoing = "outgoing",
  unknown = "unknown",
}

export enum Question {
  checkbox = "checkbox",
  comment = "comment",
  radiogroup = "radiogroup",
}

export enum QuoteScreen {
  quote_screen_1 = "quote_screen_1",
  quote_screen_2 = "quote_screen_2",
  quote_screen_3 = "quote_screen_3",
}

/**
 * TODO: Remove. Old Reachability
 */
export enum ReachabilityMedium {
  Email = "Email",
  Landline = "Landline",
  Mobile = "Mobile",
  Text = "Text",
  Web = "Web",
}

export enum ReachabilityState {
  active = "active",
  unreachable = "unreachable",
}

export enum ReachabilityStatus {
  poor = "poor",
  rich = "rich",
  unreachable = "unreachable",
}

export enum ResponseLimit {
  multiple_per_recipient = "multiple_per_recipient",
  one_per_recipient = "one_per_recipient",
}

export enum RoleBasedMessagingAudience {
  admin = "admin",
  employee = "employee",
  everyone = "everyone",
  parent = "parent",
  staff = "staff",
  student = "student",
  teacher = "teacher",
}

export enum ScheduledMessageTargetOptions {
  district = "district",
  group = "group",
}

export enum SelfServeHelpScreen {
  help_request_screen_1 = "help_request_screen_1",
  help_request_screen_2 = "help_request_screen_2",
  help_request_screen_3 = "help_request_screen_3",
}

export enum SelfServeHelpScreenSource {
  admin_contact = "admin_contact",
  admin_onboarding = "admin_onboarding",
  marketing_page = "marketing_page",
  self_serve = "self_serve",
  self_serve_v2 = "self_serve_v2",
}

export enum SetLanguageForUserInputTargetType {
  group = "group",
  organization = "organization",
}

export enum SftpFeature {
  AutoMessaging = "AutoMessaging",
}

export enum SisSyncIssueSeverity {
  alert = "alert",
  error = "error",
}

export enum SocialMediaPlatform {
  facebook = "facebook",
  instagram = "instagram",
  twitter = "twitter",
}

/**
 * Can be any of the types returned by /v2/devices.
 */
export enum SubscriptionMedium {
  apns = "apns",
  email = "email",
  gcm = "gcm",
  landline = "landline",
  sms = "sms",
  web = "web",
}

export enum SurveyOrganizationType {
  group = "group",
  organization = "organization",
}

export enum SyncType {
  aeries = "aeries",
  classlink = "classlink",
  clever = "clever",
  none = "none",
  oneRosterSpreadsheet = "oneRosterSpreadsheet",
  oneRosterSpreadsheetV1P2 = "oneRosterSpreadsheetV1P2",
  remindSpreadsheet = "remindSpreadsheet",
  remindSpreadsheetV2 = "remindSpreadsheetV2",
  skyward = "skyward",
}

export enum TabbedOrganizationScreenTab {
  calls = "calls",
  classes = "classes",
  conversations = "conversations",
  files = "files",
  information = "information",
  messages = "messages",
  overview = "overview",
  people = "people",
  schools = "schools",
  settings = "settings",
  sisSync = "sisSync",
  statistics = "statistics",
  surveys = "surveys",
}

export enum TranslationIntent {
  auto = "auto",
  edited = "edited",
  off = "off",
}

export enum UserDefinedOrganizationType {
  District = "District",
  HigherEducation = "HigherEducation",
  Other = "Other",
  School = "School",
}

export enum UserSelectedRole {
  admin = "admin",
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export interface AddParentRelationshipInput {
  parent_id: number;
  child_id: number;
}

export interface AddRemoveAdminInput {
  organizationId: number;
  userUuid: string;
}

export interface AddUserParentInput {
  organizationUuid?: string | null;
  childUuid: string;
  name: string;
  address: any;
}

export interface AddUsersToGroupInput {
  groupUuid: string;
  uuids: string[];
}

/**
 * Autogenerated input type of AdminAddContactInfoToUser
 */
export interface AdminAddContactInfoToUserInput {
  deviceUid: string;
  targetUserUuid: string;
  organizationUuid: string;
  confirmAction?: AdminAddContactInfoConfirmationActionEnum | null;
  deviceUidToRemove?: string | null;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of AdminChangeRolesForUsers
 */
export interface AdminChangeRolesForUsersInput {
  organizationUuid: string;
  userUuids: string[];
  roles: OrganizationRole[];
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of AdminRemoveContactInfoFromUser
 */
export interface AdminRemoveContactInfoFromUserInput {
  userUuid: string;
  deviceUuid: string;
  organizationUuid: string;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of AdminRemoveGroupsFromOrgs
 */
export interface AdminRemoveGroupsFromOrgsInput {
  groupUuids: string[];
  clientMutationId?: string | null;
}

export interface ApproveGroupMembershipRequestsInput {
  groupUuid: string;
  requestUuids: string[];
}

/**
 * Autogenerated input type of ApproveLinkGroupToOrgRequests
 */
export interface ApproveLinkGroupToOrgRequestsInput {
  orgUuid: string;
  linkGroupToOrgRequestUuids: string[];
  clientMutationId?: string | null;
}

export interface AutoMessageContentInput {
  body: string;
  fileAttachmentUuids?: (string | null)[] | null;
}

export interface AutoMessageSenderInput {
  uuid: string;
  type: string;
}

export interface CancelGroupMembershipRequestInput {
  groupUuid: string;
}

export interface CancelPhoneCallInput {
  phoneCallUuid: string;
}

export interface ClaimAccountScreenInput {
  claimToken: string;
}

export interface ClaimDeviceInput {
  claimToken: string;
  mergeAccounts: boolean;
}

/**
 * Attriutes for deciding messages for denial of teacher approval
 */
export interface ClassApprovalsDecidingMessages {
  userUuid: string;
  message: string;
}

export interface CreateAndChargeNewOrgCardInput {
  orgUuid: string;
  orgId: number;
  stripeSourceId: string;
  amount: number;
  quoteUuid: string;
}

export interface CreateOrganizationUnauthedInput {
  name: string;
  city: string;
  state: string;
  country?: string | null;
  type: OrganizationType;
  clientUuid: string;
}

export interface CreateRosteringJobInput {
  sourceDistrictId: string;
  remindDistrictUuid: string;
  schools: SourceSchool[];
  configKey?: string | null;
}

/**
 * Autogenerated input type of CreateSurvey
 */
export interface CreateSurveyInput {
  organizationUuid: string;
  classUuid?: string | null;
  title: string;
  description?: string | null;
  picture?: string | null;
  questions: SurveyQuestion[];
  responseLimit: ResponseLimit;
  autoContentInfo: AutoContentInfo[];
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of CreateSurveyResponse
 */
export interface CreateSurveyResponseInput {
  token: string;
  answers: SurveyAnswer[];
  clientMutationId?: string | null;
}

export interface DeleteAutoMessageInput {
  uuid: string;
}

/**
 * Autogenerated input type of DeleteScheduledMessage
 */
export interface DeleteScheduledMessageInput {
  messageUuid: string;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of DeleteSurvey
 */
export interface DeleteSurveyInput {
  uuid: string;
  clientMutationId?: string | null;
}

export interface DeliveryReportInput {
  streamUuid: string;
  messageUuid: string;
}

export interface DenyGroupMembershipRequestsInput {
  groupUuid: string;
  requestUuids: string[];
}

/**
 * Autogenerated input type of DenyLinkGroupToOrgRequests
 */
export interface DenyLinkGroupToOrgRequestsInput {
  orgUuid: string;
  linkGroupToOrgRequestUuids: string[];
  denialMessage: string;
  clientMutationId?: string | null;
}

export interface DetectLanguageInput {
  text: string;
}

/**
 * Used to filter to a specific device type and reachability type
 */
export interface DeviceReachabilityFilterInput {
  deviceType: OrganizationChartsDeviceType;
  reachabilityType: OrganizationChartsReachabilityType;
}

export interface DirectAddAdminInput {
  organizationId: number;
  name: string;
  email: string;
}

export interface DirectAddUser {
  name: string;
  role: string;
  devices: (string | null)[];
  preferredLanguageCode?: string | null;
  birthdate?: string | null;
}

export interface DirectAddUsersInput {
  targetModel: string;
  targetId: number;
  users: DirectAddUser[];
}

export interface EditFeatureSftpCredentialsInput {
  orgUuid: string;
  username: string;
  displayName: string;
  featureName: SftpFeature;
}

export interface GenerateFeatureSftpCredentialsInput {
  orgUuid: string;
  displayName: string;
  featureName: SftpFeature;
}

export interface InitiateCallInput {
  callerUuid: string;
  calleeUuid: string;
}

export interface JoinGroupByCodeInput {
  groupCode: string;
  message?: string | null;
}

export interface LanguageSetFiltersInput {
  roles?: LanguageSetRecipientsRole[] | null;
  grades?: LanguageSetRecipientsGrade[] | null;
  rostered?: LanguageSetRecipientsRostered[] | null;
}

export interface LanguageSetInput {
  targetType: LanguageSetInputTargetType;
  targetUuid: string;
  filters?: LanguageSetFiltersInput | null;
}

export interface LeadInput {
  requesterFirstName: string;
  requesterLastName: string;
  requesterEmail: string;
  requesterPhoneNumber?: string | null;
  orgType: UserDefinedOrganizationType;
  orgName: string;
  orgPostalCode: string;
  orgCountry: string;
  studentsCount: number;
  clientUuid: string;
  source?: string | null;
}

export interface LinkPreviewInput {
  url: string;
  title: string;
  description?: string | null;
  image?: string | null;
  image_width?: string | null;
  image_height?: string | null;
  rich_content_type?: string | null;
  rich_content_url?: string | null;
}

/**
 * Autogenerated input type of LinkSocialMedia
 */
export interface LinkSocialMediaInput {
  orgUuid: string;
  clientMutationId?: string | null;
}

export interface MessageInput {
  body?: string | null;
  fileUuids?: string[] | null;
  linkPreviews?: LinkPreviewInput[] | null;
  translations?: MessageTranslationsInput | null;
  personalizedVoiceMessage?: boolean | null;
  personalizedVoiceMessageFileUuid?: string | null;
  urgent?: boolean | null;
  callAllDevices?: boolean | null;
}

export interface MessageTargetFilterInput {
  roles?: MessageRecipientsRole[] | null;
  grades?: MessageRecipientsGrade[] | null;
  sisLinked?: MessageRecipientsRostered[] | null;
}

export interface MessageTranslationsInput {
  autoTranslateAll?: boolean | null;
  translated?: boolean | null;
  originalLanguageCode?: string | null;
  targetLanguageCodes?: string[] | null;
  predefinedTranslations?: PredefinedMessageTranslationsInput[] | null;
}

/**
 * Autogenerated input type of NotifyOwnersOfUnclaimedClasses
 */
export interface NotifyOwnersOfUnclaimedClassesInput {
  districtUuid: string;
  schoolsUuids: string[];
  clientMutationId?: string | null;
}

export interface OrganizationAddressInput {
  latitude?: number | null;
  longitude?: number | null;
  streetAddress: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export interface OrganizationHomeScreenInput {
  uuid: string;
  legacyKind: EntityType;
}

export interface PredefinedMessageTranslationsInput {
  languageCode: string;
  translatedText: string;
  translationSource: MessageTranslationSource;
  translationIntent?: MessageTranslationIntent | null;
}

export interface PutMessageInput {
  uuid?: string | null;
  recipients: RecipientInput[];
  message: MessageInput;
  sender?: SenderInput | null;
  postTo?: (SocialMediaCrossPostInput | null)[] | null;
}

export interface PutStudentIdListInput {
  uuid: string;
  fileUuid: string;
  organizationUuid: string;
  includeParents?: boolean | null;
  includeStudents?: boolean | null;
}

export interface QueryOrganizationsByNameInput {
  name: string;
}

export interface QuoteInput {
  organizationUuid: string;
  studentsCount: number;
  teachersCount: number;
  startDate: string;
  organizationAddress: OrganizationAddressInput;
  requesterFirstName?: string | null;
  requesterLastName?: string | null;
  requesterEmail?: string | null;
  requesterPhoneNumber: string;
  requesterRole?: string | null;
  billingFirstName?: string | null;
  billingLastName?: string | null;
  billingEmail?: string | null;
  billingPhoneNumber?: string | null;
  taxExempt?: boolean | null;
  purchaseOrderNumber?: string | null;
  lastScreenName?: string | null;
  screen?: QuoteScreen | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmContent?: string | null;
  utmCampaign?: string | null;
  experiment?: string | null;
  experimentVariant?: string | null;
}

/**
 * Used to filter user level data for reachability - only one filter can be used at a time
 */
export interface ReachabilityDetailsFilter {
  deviceReachability?: DeviceReachabilityFilterInput | null;
  reachableStatus?: OrganizationChartsReachabilityStatusFilter | null;
}

export interface RecipientInput {
  type: string;
  uuid: string;
  role?: MessageRecipientsRole | null;
  filters?: MessageTargetFilterInput[] | null;
}

export interface ReleaseHoldsInput {
  schoolUuids: string[];
}

export interface RemoveGroupFromOrgInput {
  groupUuid: string;
  organizationUuid: string;
  reason?: string | null;
}

/**
 * Autogenerated input type of RemoveGroupOwner
 */
export interface RemoveGroupOwnerInput {
  userUuid: string;
  groupUuid: string;
  clientMutationId?: string | null;
}

export interface RemoveParentRelationshipInput {
  parent_id: number;
  child_id: number;
}

export interface RemoveUsersFromGroupInput {
  groupUuid: string;
  ids: number[];
}

export interface ReportUserInput {
  userUuid: string;
  reason: string;
  key?: string | null;
  distanceLearningSessionUUID?: string | null;
}

export interface RequestAccessForPaidUpsellInput {
  organizationUuid: string;
  context: string;
  adminReferrals?: string[] | null;
  permissionToUseName: boolean;
}

/**
 * Autogenerated input type of RequestLinkGroupToOrg
 */
export interface RequestLinkGroupToOrgInput {
  orgUuid: string;
  groupUuid: string;
  requestMessage: string;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of RequestTeacherApproval
 */
export interface RequestTeacherApprovalInput {
  userUuid: string;
  organizationUuid: string;
  clientMutationId?: string | null;
}

export interface ResendUnclaimedNotificationInput {
  orgUuid: string;
}

export interface ResumeRosteringInput {
  orgUuid: string;
  holdKey: string;
  skipPermanently: boolean;
  skipUntilSuccessful: boolean;
}

export interface RevokeFeatureSftpCredentialsInput {
  orgUuid: string;
  featureName: SftpFeature;
  username: string;
}

export interface SaveAutoMessageInput {
  uuid?: string | null;
  messageName?: string | null;
  csvName?: string | null;
  orgUuid?: string | null;
  creatorOrgUuid?: string | null;
  includeParents?: boolean | null;
  includeStudents?: boolean | null;
  sender?: AutoMessageSenderInput | null;
  messageContent?: AutoMessageContentInput | null;
  sftpCredentialsUsername?: string | null;
  customMessageFields?: string[] | null;
  isUrgent?: boolean | null;
}

export interface ScheduleMessageInput {
  messageInput: PutMessageInput;
  sendAt?: string | null;
}

export interface SchoolMappingInput {
  schoolId: string;
  remindSchoolUuid: string;
}

export interface SelfServeHelpInput {
  organizationUuid: string;
  requesterFirstName?: string | null;
  requesterLastName?: string | null;
  requesterEmail?: string | null;
  requesterPhoneNumber: string;
  requesterRole?: string | null;
  quoteUuid?: string | null;
  studentsCount: number;
  teachersCount: number;
  screen?: SelfServeHelpScreen | null;
  source?: SelfServeHelpScreenSource | null;
  comment?: string | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmContent?: string | null;
  utmCampaign?: string | null;
  experiment?: string | null;
  experimentVariant?: string | null;
}

export interface SendActivationNotificationsInput {
  orgUuid: string;
  roles: string[];
}

export interface SenderInput {
  type: string;
  uuid: string;
}

export interface SetAutoMessageStatusInput {
  uuid: string;
  status: AutoMessageStatus;
}

export interface SetDistrictSettingsInput {
  orgId: number;
  schoolAdminsCanSendUrgentMessage: boolean;
}

export interface SetLanguageForUserInput {
  userUuid: string;
  targetUuid: string;
  targetType: SetLanguageForUserInputTargetType;
  preferredLanguageCode: string;
}

/**
 * Autogenerated input type of SetMessageVisibility
 */
export interface SetMessageVisibilityInput {
  streamUuid: string;
  messageUuid: string;
  visibility: MessageVisibilityEnum;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of SetOrgClassApprovalSettings
 */
export interface SetOrgClassApprovalSettingsInput {
  orgUuid: string;
  gateClasses: boolean;
  clientMutationId?: string | null;
}

export interface SetOrgSettingsInput {
  orgUuid: string;
  orgRequestToJoinEnabledDefault: boolean;
  orgSearchabilityDefault: ClassSearchability;
  orgParticipantMessagingDefault: ParticipantMessagingState;
  backfillExistingClasses: boolean;
  isLockingClassesSettings: boolean;
}

/**
 * Autogenerated input type of SetOrgTeacherApprovalSettings
 */
export interface SetOrgTeacherApprovalSettingsInput {
  orgUuid: string;
  gateTeacherRole: boolean;
  clientMutationId?: string | null;
}

export interface SetRequestToJoinInput {
  groupUuid: string;
  enabled: boolean;
}

export interface SetRosteringEnforcementInput {
  orgUuid: string;
  allowedToLeave: boolean;
}

export interface SocialMediaCrossPostInput {
  integrationProfileUuid?: string | null;
  socialMediaPlatform: SocialMediaPlatform;
}

export interface SourceSchool {
  source_id: string;
  source_name: string;
  remind_org_uuid: string;
}

/**
 * Survey answer to a question
 */
export interface SurveyAnswer {
  surveyQuestionUuid: string;
  value?: string | null;
  options?: string[] | null;
}

/**
 * Survey question structure
 */
export interface SurveyQuestion {
  type: Question;
  title: string;
  options?: string[] | null;
  required?: boolean | null;
}

export interface TranslatedMessageInput {
  languageCode: string;
  text: string;
  targetLanguageCode: string;
}

/**
 * Autogenerated input type of UnlinkSocialMedia
 */
export interface UnlinkSocialMediaInput {
  orgUuid: string;
  socialMedia: string;
  clientMutationId?: string | null;
}

export interface UpdateBirthdateInput {
  userUuid: string;
  birthdate: string;
}

export interface UpdateClassSettingsScreenInput {
  organizationUuid?: string | null;
  className?: string | null;
  classCode?: string | null;
  willOnlyMessage13AndOlder?: boolean | null;
  requestToJoinEnabled?: boolean | null;
  searchability?: ClassSearchability | null;
  participantMessagingState?: ParticipantMessagingState | null;
  isSearchable?: boolean | null;
}

export interface UpdateContentSourceProviderInput {
  title: string;
  providerIconUrl?: string | null;
  providerIconFileUUID?: string | null;
  organizationUUID: string;
  contentWebhookUrl: string;
  enabledByProvider: boolean;
  bigPreviewWebhookUrl: string;
  productLongDescription: string;
  productShortDescription: string;
}

export interface UpdateLinkedAccountProviderOauthConfigInput {
  authUrl: string;
  clientId: string;
  tokenUrl: string;
  scopes: string[];
  providerKey: string;
  clientSecret: string;
  organizationUUID: string;
}

export interface UpdateSchoolMappingsInput {
  districtUuid: string;
  schools: SchoolMappingInput[];
}

/**
 * Autogenerated input type of UpdateSurvey
 */
export interface UpdateSurveyInput {
  surveyUuid: string;
  organizationUuid: string;
  classUuid?: string | null;
  title: string;
  description?: string | null;
  picture?: string | null;
  questions: SurveyQuestion[];
  responseLimit: ResponseLimit;
  autoContentInfo: AutoContentInfo[];
  closed: boolean;
  clientMutationId?: string | null;
}

export interface UpdateUserByIDInput {
  id?: number | null;
  uuid?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  organization_uuid?: string | null;
  group_uuid?: string | null;
}

export interface UpdateUserNoteInput {
  userId: number;
  note: string;
}

export interface UpdateUserOrgsInput {
  organization_ids: number[];
}

/**
 * Some ACI setup do not require configs, for example Schoology.
 */
export interface UpsertAdminControlledIntegrationInput {
  config?: UpsertAdminControlledIntegrationInputConfig | null;
  initialIntegrationKey?: string | null;
  enabledByOrg?: boolean | null;
}

export interface UpsertAdminControlledIntegrationInputConfig {
  clientID: string;
  clientSecret: string;
  installationURLDomain: string;
}

export interface UpsertAdminToggledPartnerIntegrationInput {
  orgUuid: string;
  providerKey: string;
  isEnabled: boolean;
}

export interface UserNameChangeBanInput {
  user_identifier: string;
}

export interface UserProfileScreenInput {
  relatedUserUuid: string;
  groupUuid?: string | null;
  organizationUuid?: string | null;
}

export interface VerifyDeviceForAccountMergeInput {
  code: string;
  address: string;
}

export interface addDeviceToUserInput {
  userId: string;
  address: string;
}

/**
 * Autogenerated input type of ApproveRoleRequests
 */
export interface api_ApproveRoleRequestsInput {
  userUuids: string[];
  organizationUuid: string;
  roles: string[];
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of DenyRoleRequests
 */
export interface api_DenyRoleRequestsInput {
  userUuids: string[];
  organizationUuid: string;
  roles: string[];
  decidingMessages?: ClassApprovalsDecidingMessages[] | null;
  clientMutationId?: string | null;
}

export interface deleteLTIInput {
  organizationUUID: string;
  serviceKey: string;
}

export interface rotateLTICredentialsInput {
  organizationUUID: string;
  serviceKey: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
